import React, {
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import styled from "styled-components";
import { Link, useHistory } from "react-router-dom";
import {
  ChevronDown,
  ChevronUp,
  Gamepad,
  OrigamiIcon,
  SliceIcon,
} from "lucide-react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import ClaudeIcon from "../../../Icons/Casino";
import GameIcon from "../../../Icons/Game";
import LotteryIcon from "../../../Icons/Lottery";
import TradingIcon from "../../../Icons/Crypto";
import PromotionIcon from "../../../Icons/PromotionIcon";
import VipSvg from "../../../Icons/Vip";
import BonusIcon from "../../../Icons/BonusIcon";
import AffilateIcon from "../../../Icons/AffliateIcon";
import ProvablyFairIcon from "../../../Icons/Provably";
import HeadphoneIcon from "../../../Icons/Support";
import GlobeIcon from "../../../Icons/Glob";
import SkylaSlot from "../../../Icons/SlotsSkyla";
import SkylaLivecasino from "../../../Icons/SkylaLiveCasino";
import ClubIconMember from "../../../Icons/Club";
import {
  addNewStyle,
  CRISTP_ID,
  getUID,
  wait,
  sendNotfication,
  API,
} from "../../../Helper";
import CrashIcon from "../../../Icons/CrashIcon";
import SlotsIcon from "../../../Icons/SlotsIcon";
import { Android, Download } from "@mui/icons-material";
import { launchGame } from "../../../services/gameLaunchService";
import { launchHuiduGame } from "../../../services/huiduGameService";
import { useGameLaunch } from "../../../Context/GameLaunchContext";
import { useSelector } from "react-redux";

import Storage from "../../../Storage";

// Custom Android SVG Icon Component
const AndroidIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6 12.8C17.6 12.36 17.24 12 16.8 12H15.2C14.76 12 14.4 12.36 14.4 12.8V14.4C14.4 14.84 14.76 15.2 15.2 15.2H16.8C17.24 15.2 17.6 14.84 17.6 14.4V12.8Z"
      fill="currentColor"
    />
    <path
      d="M9.6 12.8C9.6 12.36 9.24 12 8.8 12H7.2C6.76 12 6.4 12.36 6.4 12.8V14.4C6.4 14.84 6.76 15.2 7.2 15.2H8.8C9.24 15.2 9.6 14.84 9.6 14.4V12.8Z"
      fill="currentColor"
    />
    <path
      d="M18.4 9.6H16.8V11.2H18.4C18.84 11.2 19.2 10.84 19.2 10.4C19.2 9.96 18.84 9.6 18.4 9.6Z"
      fill="currentColor"
    />
    <path
      d="M7.2 9.6H5.6C5.16 9.6 4.8 9.96 4.8 10.4C4.8 10.84 5.16 11.2 5.6 11.2H7.2V9.6Z"
      fill="currentColor"
    />
    <path
      d="M16 4.8L17.6 6.4C17.84 6.64 18.24 6.64 18.48 6.4C18.72 6.16 18.72 5.76 18.48 5.52L16.48 3.52C16.32 3.36 16.08 3.2 15.84 3.12C15.6 3.04 15.36 3 15.12 3C14.88 3 14.64 3.04 14.4 3.12C14.16 3.2 13.92 3.36 13.76 3.52L11.76 5.52C11.52 5.76 11.52 6.16 11.76 6.4C12 6.64 12.4 6.64 12.64 6.4L14.24 4.8H16Z"
      fill="currentColor"
    />
    <path
      d="M12 7.2C14.24 7.2 16 8.96 16 11.2V16.8C16 18.56 14.56 20 12.8 20H11.2C9.44 20 8 18.56 8 16.8V11.2C8 8.96 9.76 7.2 12 7.2Z"
      fill="currentColor"
    />
  </svg>
);

const SidebarContainer = styled.div`
  width: ${(props) => (props.$isCollapsed ? "76px" : "234px")};
  height: 100vh;
  background: #232626;
  position: fixed;
  left: 0;
  top: 63px;
  transition: width 0.3s ease;
  overflow-y: auto;
  color: white;
  padding-top: 56px;
  display: flex;
  z-index: 600;
  flex-direction: column;
  border-right: 1px solid #2f3536;
`;

const MenuSection = styled.div`
  padding: 12px;
  margin-top: -55px;
`;

const MenuSectionS = styled.div`
  padding: 6px 0px;
  width: 100%;
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  text-decoration: none;
  color: #9ca3af;
  border-radius: ${(props) => {
    if (props.$accordion) {
      return props.$isAccordionOpen ? "12px 12px 0 0" : "12px";
    }
    return "12px";
  }};
  margin-bottom: 2px;
  background-color: ${(props) =>
    props.$isActive ? "rgb(51, 56, 57)" : "rgb(51, 56, 57)"};
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08) !important;
    color: white;
    transform: scale(1.02);
  }

  ${(props) =>
    props.$isActive &&
    `
    background-color: rgba(255,255,255,0.08) !important;
    color: white;
  `}
`;

const BottomMenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  text-decoration: none;
  color: #9ca3af;
  margin-top: 20px;
  border-radius: ${(props) => {
    if (props.$accordion) {
      return props.$isAccordionOpen ? "12px 12px 0 0" : "12px";
    }
    return "12px";
  }};
  margin-bottom: 2px;
  background-color: ${(props) =>
    props.$isActive ? "rgb(51, 56, 57)" : "rgb(51, 56, 57)"};
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08) !important;
    color: white;
    transform: scale(1.02);
  }

  ${(props) =>
    props.$isActive &&
    `
    background-color: rgba(255,255,255,0.08) !important;
    color: white;
  `}
`;

const MenuItemVip = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #9ca3af;
  width: 100%;
  margin: 4px 0px;
  border-radius: 12px;
  padding: 8px 12px;
  background-color: ${(props) =>
    props.$isActive ? "rgb(51, 56, 57)" : "rgb(51, 56, 57)"};
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.08) !important;
    transform: scale(1.02);
  }

  ${(props) =>
    props.$isActive &&
    `
    background-color: rgba(255,255,255,0.08) !important;
  `}
`;

const OuterWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #9ca3af;
  background-color: transparent;
  border-radius: 12px;
  transition: all 0.2s ease;
`;

const IconBgNew = styled.div`
  background-color: #292d2e;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4a5354;
  }
`;

const MenuIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.$color || "inherit"};
  transition: color 0.2s ease;

  ${MenuItem}:hover & {
    color: #ffffff;
  }
`;

const VIPSpan = styled.span`
  color: #25e284;
  &:hover {
    color: white !important;
  }
`;

const ClubSpan = styled.span`
  color: white;
  &:hover {
    color: white !important;
  }
`;

const VIPContainer = styled.div`
  display: flex;
  gap: 2px;

  ${MenuItem}:hover &,
  ${MenuItemVip}:hover & ${ClubSpan} {
    color: #25ee89;
  }
`;

const MenuText = styled.span`
  display: ${(props) => (props.$isCollapsed ? "none" : "block")};
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => (props.$isActive ? "#25ee89" : "white")};
  margin-left: 12px;
  transition: color 0.2s ease;

  ${(props) =>
    props.$isSpecial &&
    `
    color: #25E284;
  `}

  ${MenuItem}:hover & {
    color: white;
  }
`;

const Divider = styled.div`
  height: 1px;
  background-color: #3a3f40;
  margin: 12px 4px;
`;

const ExternalIndicator = styled.div`
  display: ${(props) => (props.isCollapsed ? "none" : "flex")};
  align-items: center;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
`;

const IconBg = styled.div`
  padding: 6px 8px;
  background-color: rgb(41, 45, 46);
  border-radius: 10px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4a5354;
  }
`;

const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  width: ${(props) => (props.$showFull ? "128px" : "96px")};
  height: auto;
  transition: width 0.3s ease;
`;

const SubMenuContainer = styled.div`
  margin-top: -6px;
  background-color: rgb(41, 45, 46);
  display: ${(props) => (props.$isOpen ? "block" : "none")};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

const SubMenuItem = styled(Link)`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  text-decoration: none;
  color: #808a94;
  border-radius: 8px;
  margin-bottom: 4px;
  background-color: ${(props) =>
    props.$isActive ? "rgb(51, 56, 57)" : "rgb(41, 45, 46)"};
  transition: all 0.2s ease;

  &:hover {
    background-color: rgb(51, 56, 57);
    color: #ffffff;
  }
`;

const MenuItemClub = styled(MenuItemVip)`
  color: #25ee89;
  margin: 4px 0px;
  ${(props) =>
    props.$isActive &&
    `
    background: linear-gradient(90deg, rgba(255, 215, 0, 0.2), rgba(255, 215, 0, 0)) !important;
    background-color: rgba(255, 215, 0, 0.05) !important;
  `}

  ${MenuText} {
    color: #25ee89 !important;
  }

  ${MenuIcon} {
    color: #25ee89 !important;
  }

  &:hover {
    ${MenuText}, ${MenuIcon} {
      color: #25ee89 !important;
    }
  }
`;

const AppDownloadContainer = styled.div`
  padding: 12px;
  margin-top: auto;
  border-top: 1px solid #3a3f40;
`;

const AppDownloadButton = styled.a`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  text-decoration: none;
  color: #808a94;
  border-radius: 12px;
  background-color: rgb(41, 45, 46);
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background-color: rgb(51, 56, 57);
    color: white;
  }
`;

const SkylaSidebar = ({ isCollapsed }) => {
  const [activePath, setActivePath] = useState("/");
  const [openAccordions, setOpenAccordions] = useState({});
  const [openSGOriginals, setSGOriginals] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [isLogged, setIsLogged] = useState(false);
  const [show, setshow] = useState(true);
  const [launchingGame, setLaunchingGame] = useState(null); // track which game is launching
  const { setGameUrl, setIsGameOpen, setIsLuckySportGame } = useGameLaunch();
  const [enabledFeatures, setEnabledFeatures] = useState({
    promotions: true,
    vipClub: true,
    clubMembership: true,
    bonus: true,
    affiliate: true,
    Provably: true,
    casino: true,
    sports: true,
    spribe: true,
    slots: true,
    live: true,
  });
  const finalState = useSelector((state) => state.finalState.finalState);

  const handleSupportClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (window.Tawk_API && window.Tawk_API.maximize) {
        window.Tawk_API.showWidget();
        window.Tawk_API.maximize();
      }
    },
    [],
  );

  useEffect(() => {
    if (finalState && typeof finalState === "object") {
      setEnabledFeatures((prev) => ({
        ...prev,
        affiliate: finalState.affiliate ?? prev.affiliate,
        bonus: finalState.bonus ?? prev.bonus,
        casino: finalState.casino ?? prev.casino,
        clubMembership: finalState.clubmembership ?? prev.clubMembership,
        vipClub: finalState.vipclub ?? prev.vipClub,
        Provably: finalState.provablyfair ?? prev.Provably,
        sports: finalState.sports ?? prev.sports,
        spribe: finalState.spribe ?? prev.spribe,
        slots: finalState.slotsgames ?? prev.slots,
        live: finalState.alllivegames ?? prev.live,
      }));
    }
  }, [finalState]);

  const userInfo = useSelector((state) => state.userInfo.Userinfo);

  const getUserInfoagent = (data) => {
    //  console.log("helojuhchabsx", data.parent_id);

    if (
      typeof data?.parent_id === "number" &&
      Number.isInteger(data?.parent_id)
    ) {
      setshow(false);
    } else {
      setshow(true);
    }
  };
  useEffect(() => {
    getUserInfoagent(userInfo);
  }, [userInfo]);

  const handleSportsClick = async () => {
    try {
      const credits = localStorage.getItem("credit") || "0";
      const coins = localStorage.getItem("coin") || "INR";
      const id = getUID();
      const gameUrl = await launchGame(
        "92b24e4c25107367a80e0fe1a97c24e4",
        id,
        coins,
        credits,
      );
      if (gameUrl) {
        setGameUrl(gameUrl);
        setIsGameOpen(true);
      } else {
        console.error("Failed to get game URL");
      }
    } catch (error) {
      console.error("Failed to launch sports game:", error);
    }
  };

  useLayoutEffect(() => {
    setOpenAccordions((prev) => ({ ...prev }));
  }, [isCollapsed]);

  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath.includes("/sports/markets")) {
      setActivePath("/sports/markets/in-play");
    } else {
      setActivePath(currentPath);
    }
  }, [window.location.pathname]);

  const toggleAccordion = (path) => {
    setOpenAccordions((prevState) => ({
      ...prevState,
      [path]: !prevState[path],
    }));
  };

  const returnPath = () => {
    return isLogged ? "/club-membership" : "/login";
  };
  const handleSportBookClick = async () => {
    try {
      const credits = localStorage.getItem("credit") || "0";
      const coins = localStorage.getItem("coin") || "INR";

      const id = getUID();
      const result = await launchHuiduGame(
        "8a704858d5deb4af1ddc722092ac7614", // BETBY game UID
        id,
        credits,
        coins,
      );

      if (result && result.game_launch_url) {
        setGameUrl(result.game_launch_url);
        setIsGameOpen(true);
      } else {
        sendNotfication("Failed to launch Sport Book", "error");
      }
    } catch (error) {
      console.error("Failed to launch sport book game:", error);
      sendNotfication(error.message || "Failed to launch Sport Book", "error");
    }
  };

  const handleLuckSportClick = async () => {
    try {
      const id = getUID();

      if (!id) {
        sendNotfication("Please login to play LUCKSPORT", "error");
        return;
      }

      const credits = localStorage.getItem("credit") || "0";
      const coins = localStorage.getItem("coin") || "INR";

      const result = await launchHuiduGame(
        "92b24e4c25107367a80e0fe1a97c24e4", // LUCKSPORT game UID
        id,
        credits,
        coins,
      );

      if (result && result.game_launch_url) {
        setGameUrl(result.game_launch_url);
        setIsLuckySportGame(true);
        setIsGameOpen(true);
      } else {
        sendNotfication("Failed to launch LUCKSPORT", "error");
      }
    } catch (error) {
      console.error("Failed to launch LUCKSPORT game:", error);
      sendNotfication(error.message || "Failed to launch LUCKSPORT", "error");
    }
  };

  const handleEsportsClick = async () => {
    try {
      const credits = localStorage.getItem("credit") || "0";
      const coins = localStorage.getItem("coin") || "INR";

      const id = getUID();
      if (!id) {
        sendNotfication("Please login to play E-Sports", "error");
        return;
      }

      const result = await launchHuiduGame(
        "4ee8e0051a035b463b47c3c473ce317d", // TFGaming/Esports game UID
        id,
        credits,
        coins,
      );

      if (result && result.game_launch_url) {
        setGameUrl(result.game_launch_url);
        setIsGameOpen(true);
      } else {
        sendNotfication("Failed to launch E-Sports", "error");
      }
    } catch (error) {
      console.error("Failed to launch esports game:", error);
      sendNotfication(error.message || "Failed to launch E-Sports", "error");
    }
  };

  const handle9WicketClick = async () => {
    try {
      const id = getUID();
      if (!id) {
        sendNotfication("Please login to play 9Wicket", "error");
        return;
      }

      // Show loader immediately while API call is in progress
      setIsGameOpen(true);

      const credits = localStorage.getItem("credit") || "0";
      const coins = localStorage.getItem("coin") || "INR";

      // Launch 9Wicket game directly in iframe using the simple endpoint
      const response = await fetch(`${API}/ninewicket/game/play`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_id: id,
          currency_code: coins,
          language: "en",
        }),
      });

      const data = await response.json();

      if (data.success && data.data && data.data.game_launch_url) {
        setGameUrl(data.data.game_launch_url);
      } else {
        const errorMsg =
          data.error || data.message || "Failed to launch 9Wicket";
        console.error("[Sidebar] Launch failed:", errorMsg);
        setIsGameOpen(false);
        sendNotfication(errorMsg, "error");
      }
    } catch (error) {
      console.error("Failed to launch 9Wicket:", error);
      setIsGameOpen(false);
      sendNotfication("Failed to launch 9Wicket: " + error.message, "error");
    }
  };

  const menuItems = useMemo(() => {
    const items = [
      {
        id: 1,
        icon: <ClaudeIcon />,
        text: "Casino",
        path: "/casino",
        accordion: false,
        isEnabled: enabledFeatures.casino,
      },

      // {
      //   id: 6,
      //   icon: <GameIcon/>,
      //   text: 'Sports Exchange',
      //   path: '/sports/markets/in-play',
      //   accordion: false,
      //   isEnabled: enabledFeatures.sports,
      // },
      {
        id: 8,
        icon: <GameIcon />,
        text: "Sports Exchange",
        path: "#",
        accordion: false,
        isEnabled: true,
      },
      // {
      //   id: 7,
      //   icon: (
      //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      //       <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#25ee89" />
      //       <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" fill="#25ee89" />
      //       <circle cx="12" cy="12" r="2" fill="#25ee89" />
      //     </svg>
      //   ),
      //   text: "Sport Book",
      //   path: "/sport-book",
      //   accordion: false,
      //   isEnabled: true,
      // },

      {
        id: 2,
        icon: (
          <svg
            width="20"
            height="20"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="50" cy="50" r="45" fill="#25ee89" />

            <path
              d="M50 5 A45 45 0 0 1 95 50 L85 45 L95 50 L85 55"
              fill="#fff"
            />
            <path
              d="M95 50 A45 45 0 0 1 50 95 L55 85 L50 95 L45 85"
              fill="#fff"
            />

            <circle
              cx="50"
              cy="50"
              r="20"
              fill="none"
              stroke="black"
              stroke-width="3"
            />
            <path
              d="M35 50 A15 15 0 0 1 65 50 A15 15 0 0 1 35 50"
              fill="none"
              stroke="black"
              stroke-width="3"
            />
          </svg>
        ),
        text: "E-Sports",

        path: "/esport",
        accordion: false,
        isEnabled: enabledFeatures.sports,
      },
      // {
      //   id: 9,
      //   text: "9Wicket",
      //   path: "/9wicket",
      //   accordion: false,
      //   isEnabled: true,
      // },
      {
        id: 3,
        icon: <LotteryIcon />,
        text: "Spribe",
        path: "/spribe-games",
        accordion: false,
        isEnabled: enabledFeatures.spribe,
      },
      {
        id: 5,
        icon: <CrashIcon />,
        text: "Live",
        path: "/live",
        accordion: false,
        isEnabled: enabledFeatures.live,
      },
      {
        id: 4,
        icon: <SlotsIcon />,
        text: "Slots",
        path: "/pm-slots",
        accordion: false,
        isEnabled: enabledFeatures.slots,
      },
    ];

    return items.filter((item) => item.isEnabled);
  }, [enabledFeatures]);

  const filteredVipItems = [
    {
      id: 0,
      icon: <PromotionIcon />,
      text: "Promotions",
      path: "/promotions",
      isEnabled: enabledFeatures.promotions,
      set: show,
    },
    {
      id: 1,
      icon: <VipSvg />,
      text: "VIP Club",
      path: "/vip-club",
      color: "#25ee89",
      isEnabled: enabledFeatures.vipClub,
      set: show,
    },
    {
      id: 3,
      icon: <BonusIcon />,
      text: "Bonus",
      path: "/bonus",
      isEnabled: enabledFeatures.bonus,
      set: show,
    },
    {
      id: 4,
      icon: <AffilateIcon />,
      text: "Affiliate",
      path: "/affiliate",
      isEnabled: enabledFeatures.affiliate,
      set: show,
    },
    {
      id: 5,
      icon: <ProvablyFairIcon />,
      text: "Provably Fair",
      path: "/provably-fair",
      isEnabled: enabledFeatures.Provably,
      set: true,
    },
    {
      id: 6,
      icon: <HeadphoneIcon />,
      text: "Live Support",
      path: "/live",
      isEnabled: enabledFeatures.Provably,
      onClick: handleSupportClick,
      set: show,
    },
    {
      id: 7,
      icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>,
      text: "WhatsApp",
      path: `https://wa.me/${finalState?.whatsapp_number || ''}`,
      isEnabled: !!(finalState?.whatsapp_enabled && finalState?.whatsapp_number),
      isExternal: true,
      set: !!(finalState?.whatsapp_enabled && finalState?.whatsapp_number),
    },
    {
      id: 8,
      icon: <svg width="20" height="20" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill="#0088cc"/><path d="M9.04 16.14l-.36-3.26 5.74-5.18c.25-.23-.05-.35-.39-.14l-7.09 4.47-3.06-.96c-.66-.18-.67-.63.15-.95l11.97-4.61c.55-.25 1.07.13.86.95l-2.04 9.6c-.14.65-.56.81-1.13.5l-3.12-2.3-1.51 1.46c-.17.17-.31.31-.56.31z" fill="#fff"/></svg>,
      text: "Telegram",
      path: `https://t.me/${finalState?.telegram_username || ''}`,
      isEnabled: !!(finalState?.telegram_enabled && finalState?.telegram_username),
      isExternal: true,
      set: !!(finalState?.telegram_enabled && finalState?.telegram_username),
    },
  ].filter((item) => item.isEnabled !== false && item.set !== false);

  const gameItems = [
    { icon: <ClaudeIcon />, text: "Crash" },
    { icon: <ClaudeIcon />, text: "FastParity" },
    { icon: <ClaudeIcon />, text: "Twist" },
    { icon: <ClaudeIcon />, text: "Plinko" },
  ];

  const history = useHistory();

  const handleDownloadAPK = () => {
    window.open("https://your-app-download-url.apk", "_blank");
  };

  return (
    <SidebarContainer $isCollapsed={isCollapsed}>
      <MenuSection>
        {menuItems.map((item) => (
          <React.Fragment key={item.id}>
            <MenuItem
              as={item.text === "Sports" ? "div" : Link}
              {...(item.text !== "Sports" && item.path
                ? { to: item.path }
                : {})}
              $accordion={item.accordion}
              $isAccordionOpen={openAccordions[item.path]}
              $isActive={
                activePath === item.path ||
                (item.path === "/sports/markets/in-play" &&
                  activePath.includes("/sports/markets"))
              }
              isCollapsed={isCollapsed}
              onClick={(e) => {
                if (item.text === "Sports") {
                  e.preventDefault();
                  handleSportsClick();
                } else if (item.text === "Sport Book") {
                  e.preventDefault();
                  handleSportBookClick();
                } else if (
                  item.text === "LUCKSPORT" ||
                  item.text === "Sports Exchange"
                ) {
                  e.preventDefault();
                  handleLuckSportClick();
                } else if (item.text === "E-Sports") {
                  e.preventDefault();
                  handleEsportsClick();
                } else if (item.text === "9Wicket") {
                  e.preventDefault();
                  handle9WicketClick();
                } else if (item.path) {
                  setIsGameOpen(false);
                  setActivePath(item.path);
                  history.push(item.path);
                }
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <LeftSection>
                  <MenuIcon $isCollapsed={isCollapsed} $color={item.color}>
                    {item.icon}
                  </MenuIcon>
                  <MenuText
                    $isActive={activePath === item.path}
                    $isCollapsed={isCollapsed}
                    $color={item.color}
                    $isSpecial={item.text === "VIP Club"}
                  >
                    {item.text === "VIP Club" ? (
                      <VIPContainer>
                        <VIPSpan>VIP</VIPSpan>
                        <ClubSpan>Club</ClubSpan>
                      </VIPContainer>
                    ) : (
                      item.text
                    )}
                  </MenuText>
                </LeftSection>
                {item.accordion && !isCollapsed && (
                  <IconBgNew>
                    <MenuIcon $isCollapsed={isCollapsed}>
                      {openAccordions[item.path] ? (
                        <ChevronUp size={18} />
                      ) : (
                        <ChevronDown size={18} />
                      )}
                    </MenuIcon>
                  </IconBgNew>
                )}
              </div>
            </MenuItem>
            {!isCollapsed && item.subMenu && openAccordions[item.path] && (
              <SubMenuContainer $isOpen={openAccordions[item.path]}>
                {item.subMenu.length > 0 ? (
                  item.subMenu.map((subItem) => (
                    <SubMenuItem
                      key={subItem.path}
                      to={subItem.path}
                      $isActive={activePath === subItem.path}
                      onClick={() => setActivePath(subItem.path)}
                      onMouseEnter={() => {
                        if (subItem.text === "Originals") setIsHovered(true);
                      }}
                      onMouseLeave={() => setIsHovered(false)}
                    >
                      <LeftSection>
                        <MenuIcon $isCollapsed={false} $color={subItem.color}>
                          {subItem.icon}
                        </MenuIcon>
                        <MenuText $isCollapsed={false}>{subItem.text}</MenuText>
                      </LeftSection>
                    </SubMenuItem>
                  ))
                ) : (
                  <div style={{ textAlign: "center", padding: "24px" }}>
                    Coming Soon
                  </div>
                )}
              </SubMenuContainer>
            )}
          </React.Fragment>
        ))}
      </MenuSection>

      <div
        style={{
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <OuterWrapper>
          <MenuSectionS>
            {filteredVipItems.map((item, index) => (
              <React.Fragment key={item.path}>
                {item.text === "Club Membership" ? (
                  <MenuItemClub
                    to={item.path}
                    $isActive={activePath === item.path}
                    $isCollapsed={isCollapsed}
                    onClick={() => { setIsGameOpen(false); setActivePath(item.path); }}
                  >
                    <LeftSection>
                      <MenuIcon $isCollapsed={isCollapsed}>
                        <ClubIconMember color="gold" />
                      </MenuIcon>
                      <MenuText
                        $isActive={activePath === item.path}
                        $isCollapsed={isCollapsed}
                      >
                        {item.text}
                      </MenuText>
                    </LeftSection>
                  </MenuItemClub>
                ) : item.text === "Live Support" ? (
                  <MenuItem
                    as="div"
                    $isActive={activePath === item.path}
                    $isCollapsed={isCollapsed}
                    onClick={item.onClick}
                  >
                    <LeftSection>
                      <MenuIcon $isCollapsed={isCollapsed}>
                        {item.icon}
                      </MenuIcon>
                      <MenuText
                        $isActive={activePath === item.path}
                        $isCollapsed={isCollapsed}
                      >
                        {item.text}
                      </MenuText>
                    </LeftSection>
                  </MenuItem>
                ) : item.isExternal ? (
                  <MenuItem
                    as="a"
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    $isCollapsed={isCollapsed}
                    style={{ textDecoration: 'none' }}
                  >
                    <LeftSection>
                      <MenuIcon $isCollapsed={isCollapsed}>
                        {item.icon}
                      </MenuIcon>
                      <MenuText
                        $isCollapsed={isCollapsed}
                      >
                        {item.text}
                      </MenuText>
                    </LeftSection>
                  </MenuItem>
                ) : (
                  <MenuItemVip
                    to={item.path}
                    $isActive={activePath === item.path}
                    onClick={() => { setIsGameOpen(false); setActivePath(item.path); }}
                  >
                    <LeftSection>
                      <MenuIcon $isCollapsed={isCollapsed}>
                        {item.icon}
                      </MenuIcon>
                      <MenuText
                        $isActive={activePath === item.path}
                        $isCollapsed={isCollapsed}
                      >
                        {item.text}
                      </MenuText>
                    </LeftSection>
                  </MenuItemVip>
                )}
                {[4, 7, 8, 12].includes(index) && <Divider />}
              </React.Fragment>
            ))}
          </MenuSectionS>
          
        </OuterWrapper>
      </div>
    </SidebarContainer>
  );
};

export default SkylaSidebar;
